import { Flex } from "@radix-ui/themes";
import { t } from "i18next";
import _ from "lodash";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { staffStatuses } from "../../enums"; // Все состояния статуса оборудования
import Category from "../../components/Filters/subFilterCategory";
import { Button } from "../../ui/Button";
import { Popover, PopoverTrigger, PopoverContent } from "../../ui/Popover";
import CategoryPopover from "../../components/Filters/subFilterPopover";

type StaffFilterType = {
  posts: Array<string>;
  divisions: Array<string>;
  statuses: Array<string>;
};

type StaffCategoriesType = {
  unique_posts_name: Array<string>;
  unique_divisions_name: Array<string>;
  unique_statuses: Array<string>;
};

type Props = {
  filterState: [StaffFilterType, Dispatch<SetStateAction<StaffFilterType>>];
  categories: StaffCategoriesType;
};

const StaffFilters = (props: Props) => {
  const posts = props.categories.unique_posts_name;
  const divisions = props.categories.unique_divisions_name;

  const statuses = props.categories.unique_statuses; // Список состояний статуса оборудования, существующих в данной выборке

  const [filter, setFilter] = props.filterState; // Общий фильтр
  const [postsFilter, setPostsFilter] = React.useState(filter.posts); // Подфильтры категорий
  const [divisionsFilter, setDivisionsFilter] = React.useState(filter.divisions);
  const [statusesFilter, setStatusesFilter] = React.useState(filter.statuses);

  React.useEffect(() => {
    setFilter({
      ...filter,
      ...{
        posts: postsFilter,
        divisions: divisionsFilter,
        statuses: statusesFilter,
      },
    });
  }, [postsFilter, divisionsFilter, statusesFilter]);

  return (
    <div className="flex gap-2 px-6 mb-2">
      <CategoryPopover categoryName={t("post")} content={posts} filterState={[postsFilter, setPostsFilter]} />
      <CategoryPopover
        categoryName={t("division")}
        content={divisions}
        filterState={[divisionsFilter, setDivisionsFilter]}
      />
      <CategoryPopover
        categoryName={t("status")}
        content={staffStatuses}
        filterState={[statusesFilter, setStatusesFilter]}
        searchbar={false}
        fixed={true}
      />
    </div>
  );
};

export default StaffFilters;
